// "Protokoll" (operator 02.11.2026, chat-520): every push to Ange.Bot and every feasibility check with what came of
// it, newest first; reached from the bell. Older entries load on request.
import type { LogEntry } from "../api";
import { loadLog, S } from "../state";
import { $, emptyState, esc, fmtDT, toast } from "../util";

const STATUS: Record<string, string> = { queued: "läuft", accepted: "angenommen", rejected: "abgewiesen", failed: "fehlgeschlagen", done: "geprüft" };
const WHAT: Record<string, string> = { indikativ: "Push (indikativ)", final: "Push (final)", knopf: "Machbarkeit (Knopf)", auto: "Machbarkeit (automatisch)" };

/** The kind and how it started: "Push (final)", "Machbarkeit (automatisch)". */
export const logWhat = (e: Pick<LogEntry, "kind" | "how">): string => WHAT[e.how ?? ""] ?? (e.kind === "push" ? "Push" : "Machbarkeit");

/** A failure stands out; a running entry is muted. */
export const logLevel = (e: Pick<LogEntry, "kind" | "status">): "crit" | "muted" | "" =>
  e.status === "failed" || e.status === "rejected" ? "crit" : e.status === "queued" ? "muted" : "";

export function renderProtokoll(): void {
  const el = $("#v-protokoll");
  const items = S.angeBotLog;
  const head = `<div class="brief-head"><span class="eyebrow">Ange.Bot</span><h1>Protokoll</h1>
    <p>Jeder Push nach Ange.Bot und jede Machbarkeitsprüfung, mit Ergebnis und Grund. Fehlschläge meldet die Glocke oben.</p></div>`;
  if (!items) {
    el.innerHTML = head + emptyState("Lade Protokoll …", "");
    return;
  }
  if (!items.length) {
    el.innerHTML = head + emptyState("Noch nichts gesendet", "Hier erscheinen Pushes nach Ange.Bot und Machbarkeitsprüfungen.");
    return;
  }
  el.innerHTML =
    head +
    `<div class="log-wrap"><table class="log"><thead><tr><th>Zeit</th><th>Was</th><th>Deal</th><th>Ergebnis</th><th>Von</th></tr></thead><tbody>${items
      .map(
        (e) => `<tr class="${logLevel(e)}"><td class="mono">${fmtDT(e.at)}</td><td>${esc(logWhat(e))}</td>
          <td><a href="#deal-${esc(e.dealId)}"><span class="mono">${esc(e.ref)}</span> ${esc(e.deal)}</a></td>
          <td><b>${esc(STATUS[e.status] ?? e.status)}</b>${e.outcome ? ` · ${esc(e.outcome)}` : ""}${e.grund ? `<small class="log-grund">Trotz fehlender Angaben: „${esc(e.grund)}“</small>` : ""}</td><td>${esc(e.by ?? (e.how === "auto" ? "automatisch" : "–"))}</td></tr>`,
      )
      .join("")}</tbody></table></div>
    ${S.angeBotLogMore ? `<button type="button" class="btn" data-log-more>Ältere laden</button>` : ""}`;
}

export function bindProtokoll(): void {
  $("#v-protokoll").addEventListener("click", (e) => {
    const more = (e.target as HTMLElement).closest<HTMLButtonElement>("[data-log-more]");
    if (!more) return;
    more.disabled = true;
    loadLog(true).then(renderProtokoll, () => ((more.disabled = false), toast("Das Protokoll konnte nicht geladen werden.")));
  });
}
